import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=824e4560"
import script from "./PdfPreview.vue?vue&type=script&lang=js"
export * from "./PdfPreview.vue?vue&type=script&lang=js"
import style0 from "./PdfPreview.vue?vue&type=style&index=0&id=824e4560&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports